import { Form } from "antd";
import type { FormInstance } from "antd/es/form/hooks/useForm";

import type { FieldMethod, FormFieldFactoryProps, SelectProfileFormField } from "../../types/types";
import { ProfileSelector } from "../index";

export const ProfileSelectorField: FieldMethod = ({ field, readOnly, rules }: FormFieldFactoryProps) => {
    return (
        <Form.Item noStyle shouldUpdate>
            {(form: FormInstance) => (
                <Form.Item key={`${field.name}FormItem`} name={field.name} rules={rules}>
                    <ProfileSelector
                        key={field.name}
                        name={field.name}
                        label={field.translationKeys.label}
                        fieldConfig={field as SelectProfileFormField}
                        readOnly={readOnly}
                        formInstance={form}
                    />
                </Form.Item>
            )}
        </Form.Item>
    );
};
